<template>
  <b-card :title="`Daftar Pembayaran (${datas.length} Invoice)`">
    <b-table-simple
      borderless
    >
      <b-tbody>
        <b-tr
          v-for="(item, index) in datas"
          :key="`item-data-${index}`"
        >
          <b-td class="pl-0 pb-0">
            <div class="d-flex">
              <div class="mr-1">
                {{ index + 1 }}.
              </div>
              <dl>
                <dt>
                  <div
                    v-if="item.id === id"
                  >
                    {{ item.invoice_number }} <small class="text-muted">Transaksi saat ini</small>
                  </div>
                  <div
                    v-else-if="$store.state.auth.userData.role === 'merchant'"
                  >
                    {{ item.invoice_number }}
                  </div>
                  <a
                    v-else
                    class="text-primary"
                    @click="toDetailTransaction(item.id)"
                  >
                    {{ item.invoice_number }}
                  </a>
                </dt>
                <dd>{{ item.merchant.name }}</dd>
              </dl>
            </div>
          </b-td>
          <b-td class="text-right pb-0">
            {{ getTotalPay(item) }}
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </b-card>
</template>

<script>
import {
  BCard,
  BTableSimple,
  BTr,
  BTbody,
  BTd,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BTableSimple,
    BTr,
    BTbody,
    BTd,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {}
  },
  computed: {
    datas() {
      if (this.data.order_groups) return this.data.order_groups.transactions

      const data = [
        {
          merchant: this.data.merchant,
          total: this.data.total,
          invoice_number: this.data.invoice_number,
          id: this.data.id,
        },
      ]

      return data
    },
    id() {
      return this.$route.params.id
    },
  },
  methods: {
    getTotalPay(data) {
      let paid = 0

      if (data.with_shipping) {
        paid = data.total + data.shipping.fee + (data.delivery_insurance_fee || 0)
      } else {
        paid = data.total
      }

      return this.toCurrency(paid)
    },
    toDetailTransaction(idTransaction) {
      this.$store.commit('transaction/RESET_TRANSACTION')
      this.$emit('reload', idTransaction)
      this.$router.replace(`/transactions/${idTransaction}/detail`)
    },
  },
}
</script>

<style lang="scss" scoped>
dt {
    font-weight: bolder !important;
}
</style>
